import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1ae8a75a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=1ae8a75a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8a75a",
  null
  
)

export default component.exports